var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.55 20.9242L5.25 12.6492C5.16667 12.5492 5.10433 12.4449 5.063 12.3362C5.021 12.2282 5 12.1159 5 11.9992C5 11.8826 5.021 11.7659 5.063 11.6492C5.10433 11.5326 5.16667 11.4326 5.25 11.3492L13.575 3.02422C13.7917 2.80755 14.0627 2.69922 14.388 2.69922C14.7127 2.69922 14.9917 2.81589 15.225 3.04922C15.4583 3.28255 15.575 3.55755 15.575 3.87422C15.575 4.19089 15.4583 4.46589 15.225 4.69922L7.925 11.9992L15.225 19.2992C15.4583 19.5159 15.571 19.7826 15.563 20.0992C15.5543 20.4159 15.4333 20.6909 15.2 20.9242C14.9667 21.1576 14.6917 21.2742 14.375 21.2742C14.0583 21.2742 13.7833 21.1576 13.55 20.9242Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.506a724c0ab56802e58d7dfaa23fcd8c.svg";
export { ForwardRef as ReactComponent };